import React from "react";
import { Button, Row, Col, Modal } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import {
  NEXT_ENGINE_LINK_URL,
  NEXT_ENGINE_CLIENT_ID,
  NEXT_ENGINE_REDIRECT_URL,
  MODE_SURVEY,
  surveyTypeEc,
} from "../constants";
import { pushTo } from "utils/navigation";

interface NextEngineLinkModalProps {
  visible: boolean;
  showFooter: boolean;
  isFinished: boolean;
  onCloseModal: () => void;
}

const NextEngineLinkModal: React.FC<NextEngineLinkModalProps> = ({
  visible,
  showFooter,
  isFinished,
  onCloseModal,
}) => {
  const history = useHistory();
  const location = useLocation();
  const handleCancel = () => {
    if (isFinished) {
      pushTo(history, location.pathname, {
        mode: MODE_SURVEY,
        surveyType: surveyTypeEc,
      });
    }
    onCloseModal();
  };

  const handleOnClickLink = () => {
    window.location = `${NEXT_ENGINE_LINK_URL}?client_id=${NEXT_ENGINE_CLIENT_ID}&redirect_uri=${NEXT_ENGINE_REDIRECT_URL}` as any;
  };

  let footer: Array<any> = [];
  if (showFooter) {
    footer = [
      <Button key="closeModal" type="primary" onClick={handleCancel}>
        {i18n.t("ecSettings.link.closeModal")}
      </Button>,
    ];
  }

  let finishedTextDisplay: any;
  let nextEngineLinkButtonDisplay: any = (
    <Button type="default" onClick={handleOnClickLink}>
      {i18n.t("ecSettings.link.linkNextEngineTitle")}
    </Button>
  );
  if (isFinished) {
    finishedTextDisplay = (
      <Row>
        <Col span={22}>
          <h2>{i18n.t("ecSettings.link.linkFinishedTitle")}</h2>
          <span>{i18n.t("ecSettings.link.linkFinishedDescription")}</span>
        </Col>
      </Row>
    );
    nextEngineLinkButtonDisplay = null;
  }

  return (
    <Modal
      title={i18n.t("ecSettings.link.linkNextEngineTitle")}
      visible={visible}
      onCancel={handleCancel}
      footer={footer}
    >
      {finishedTextDisplay}
      <Row>
        <Col xs={22} sm={19}>
          {nextEngineLinkButtonDisplay}
        </Col>
      </Row>
    </Modal>
  );
};

export default NextEngineLinkModal;
